import React from "react";
import ReactDOM from "react-dom";
import EmailIcon from "@material-ui/icons/Email";
import Grid from "@material-ui/core/Grid";
import HomeIcon from '@material-ui/icons/Home';
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import TwitterIcon from '@material-ui/icons/Twitter';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import InstagramIcon from '@material-ui/icons/Instagram';
import "./index.css";

const Contact = () => {
  return (
    <>
      <section class="contact" id="contact">
        <div class="max-width">
          <h2 class="title">Contact Me</h2>
          <div class="contact-content">
            <div class="column left">
              <div class="text">Get in <span>Touch</span></div>
              <p>
                You can always connect with me and I will be very happy to help
                & collaborate. I am giving my Social Media handles. Keep Learning!
              </p>
              <div class="icons">
                <div class="row">
                  <i class="fas fa-user"></i>
                  <div class="info">
                    <div class="head">
                    <Grid container direction="row" alignItems="center">
                        <EmojiPeopleIcon />  <span> Name</span>
                      </Grid>
                      </div>
                    <div class="sub-title">Sakshat Mali</div>
                  </div>
                </div>
                <div class="row">
                  <i class="fas fa-map-marker-alt"></i>
                  <div class="info">
                    <div class="head">
                    <Grid container direction="row" alignItems="center">
                        <HomeIcon />  <span> Address</span>
                      </Grid>
                        </div>
                    <div class="sub-title">Delhi, India</div>
                  </div>
                </div>
                <div class="row">
                  <i class="fas fa-envelope"></i>
                  <div class="info">
                    <div class="head">
                      <Grid container direction="row" alignItems="center">
                        <EmailIcon />  <span> Email</span>
                      </Grid>
                    </div>
                    <div class="sub-title">sakshatmali@gmail.com</div>
                  </div>
                </div>
                <div class="row">
                  <i class="fas fa-envelope"></i>
                  <div class="info">
                    <div class="head">
                    <Grid container direction="row" alignItems="center">
                        <LinkedInIcon />  <span> Linkedin</span>
                      </Grid>
                    </div>
                    <div class="sub-title">
                      <a
                        href="https://www.linkedin.com/in/sakshat-mali"
                        target="_blank"
                      >
                        Sakshat Mali
                      </a>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <i class="fas fa-envelope"></i>
                  <div class="info">
                    <div class="head">
                    <Grid container direction="row" alignItems="center">
                        <TwitterIcon />  <span> Twitter</span>
                      </Grid>
                    </div>
                    <div class="sub-title">
                      <a
                        href="https://twitter.com/SakshatMali?s=08"
                        target="_blank"
                      >
                        @SakshatMali
                      </a>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <i class="fas fa-envelope"></i>
                  <div class="info">
                    <div class="head">
                    <Grid container direction="row" alignItems="center">
                        <InstagramIcon />  <span> Instagram</span>
                      </Grid>
                    </div>
                    <div class="sub-title">
                      <a
                        href="https://www.instagram.com/sakshat_mali/"
                        target="_blank"
                      >
                        sakshat_mali
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="column right">
              <div class="text">Message <span>Me</span></div>
              <form action="#">
                <div class="fields">
                  <div class="field name">
                    <input type="text" placeholder="Name" required />
                  </div>
                  <div class="field email">
                    <input type="email" placeholder="Email" required />
                  </div>
                </div>
                <div class="field">
                  <input type="text" placeholder="Subject" required />
                </div>
                <div class="field textarea">
                  <textarea
                    cols="30"
                    rows="10"
                    placeholder="Message.."
                    required
                  ></textarea>
                </div>
                <div class="button">
                  <button type="submit">Send Message</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
